"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const timer_1 = require("../styles/timer");
const utils_1 = require("../utils");
const hooks_1 = require("../utils/hooks");
const ExpirationClock = ({ expirationDate, onTimeOut, stopped, transparent, expired }) => {
    const getRemainingTime = () => (0, utils_1.getDateDifferenceFromNow)(expirationDate);
    const [timeLeft, setTimeLeft] = (0, react_1.useState)(getRemainingTime());
    const isIntense = (seconds) => seconds < 5 * 60 && seconds > 1;
    const [intense, setIntense] = (0, react_1.useState)(isIntense(timeLeft / 1000));
    const updateClock = () => {
        const remaining = getRemainingTime();
        setTimeLeft(remaining);
        const seconds = remaining / 1000;
        if (seconds <= 0 && !expired)
            onTimeOut();
        setIntense(isIntense(seconds));
    };
    const clearInterval = (0, hooks_1.useInterval)(updateClock, 1000, expirationDate);
    (0, react_1.useEffect)(() => {
        if (stopped)
            clearInterval();
    }, [stopped]);
    return ((0, jsx_runtime_1.jsx)(timer_1.Clock, { intense: intense, isTransparent: transparent, children: (0, utils_1.formatDateDifference)(timeLeft <= 0 ? 0 : timeLeft) }));
};
exports.default = ExpirationClock;
